<template>
  <v-main style="min-height: 70vh">
    <div class="responsive-template-content" style="padding: 1em">
      <v-row dense>
        <v-col cols="12">
          <v-card
            color="white"
            dark
            elevation="6"
            class="rounded-xl"
            style="padding: 2em"
          >
            <v-row dense>
              <v-col cols="12">
                <v-alert
                  outlined
                  type="error"
                  text
                  prominent
                  border="left"
                  style="margin-top: 1em"
                  v-if="formErrors.length > 0"
                >
                  <ul>
                    <li v-for="(error, index) in formErrors" :key="index">
                      • {{ error }}
                    </li>
                  </ul>
                </v-alert>
                Complétez les informations
              </v-col>
              <v-col cols="12" md="8">
                <v-combobox
                  light
                  v-model="seekerModel"
                  :items="items"
                  :loading="isLoading"
                  :search-input.sync="search"
                  prepend-inner-icon="mdi-electron-framework"
                  chips
                  small-chips
                  clearable
                  hide-details
                  hide-selected
                  item-text="name"
                  item-value="symbol"
                  label="Métier, mots clés ou entreprise"
                  solo
                  multiple
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-title>
                        Entrer un métier, mots clés ou entreprise pour
                        rechercher
                        <strong>des Cvs</strong>
                      </v-list-item-title>
                    </v-list-item>
                  </template>
                  <template v-slot:item="{ item }">
                    <v-list-item-content>
                      <v-list-item-title v-text="item.name"></v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-combobox>
              </v-col>

              <v-col cols="12" md="3">
                <v-btn
                  elevation="24"
                  x-large
                  rounded
                  color="primary"
                  style="width: 100%"
                  v-on:click="searchSeeker"
                >
                  <v-icon left> mdi-magnify </v-icon>
                  Rechercher
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" v-if="!displayResults">
          <v-row v-if="this.seekers.length > 0">
            <v-col cols="4">
              <v-card>
                <v-card-title>Profils</v-card-title>
                <v-card-text>
                  <v-list
                    style="
                      max-height: 1500px;
                      overflow-y: scroll;
                      overflow-x: hidden;
                    "
                  >
                    <v-list-item
                      light
                      v-for="(item, index) in this.seekers"
                      :key="index"
                      link
                      style="border-bottom: 1px solid #082c64"
                      v-on:click="
                        refreshCvView(
                          item.account.id,
                          index,
                          item.defaultCvTemplate !== null
                            ? item.defaultCvTemplate.id
                            : null
                        )
                      "
                    >
                      <v-list-item-content class="mr-2">
                        <v-row>
                          <v-col cols="3">
                            <v-list-item-avatar>
                              <v-img
                                :src="
                                  item.account.userAvatar === null
                                    ? `unknow.png`
                                    : avatarUrl +
                                      item.account.userAvatar.fileName
                                "
                              ></v-img>
                            </v-list-item-avatar>
                          </v-col>
                          <v-col cols="9">
                            <v-row class="mt-2"
                              ><v-list-item-title
                                >{{ item.account.firstname }}
                                {{ item.account.lastname }}</v-list-item-title
                              ></v-row
                            >
                            <v-row>
                              <v-list-item-subtitle>
                                {{ item.cvTitle }}
                              </v-list-item-subtitle>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="8">
              <v-card>
                <v-card-title>CV du candidat</v-card-title>
                <v-card-actions>
                  <a
                    :href="candidateCV"
                    class="v-btn"
                    target="_blank"
                    v-if="candidateCV !== '#'"
                    >Télécharger le CV</a
                  >
                </v-card-actions>
                <v-card-text>
                  <iframe
                    id="cvPrevisualizer"
                    :src="this.cvData.cvPrevisualisationLink"
                    width="100%"
                    height="1500px"
                    v-if="visible"
                  >
                  </iframe>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" v-if="displayResults">
          <!-- todo -->
        </v-col>
      </v-row>
    </div>
  </v-main>
</template>

<script>
import HttpClient from "@/services/HttpClient/HttpClient";
import { timeSince } from "@/helper/DateTimeHelper.js";
import Vue from "vue";

export default Vue.extend({
  name: "CompanyCvTheque",
  data: function () {
    return {
      visible: true,
      apiHost: null,
      cvData: {
        cvPrevisualisationEndpoint: `/api/company/preview-resume/`,
        cvDownloadEndpoint: `/api/company/preview-resume/`,
        cvPrevisualisationLink: null,
        cvPrevisualisationContent: null,
        selectedTemplate: null,
        avatar: null,
      },
      candidateCV: "#",
      avatarUrl: `${process.env.VUE_APP_JOB_BOARD_API_ENDPOINT}/uploads/avatar/`,
      isLoading: false,
      items: [],
      seekerModel: null,
      where: null,
      search: null,
      locationSearch: null,
      tab: null,
      locationTab: null,
      selected: [2],
      formErrors: [],
      currentSeeker: null,
      currentCvFilePath: null,
      displayResults: false,
      seekers: [],
      jobsItems: [],
      page: 1,
      perPage: 5,
      displayJobOffer: false,
      jobOfferToView: null,
      renderViewJobModal: false,
      locationIsLoading: false,
    };
  },
  mounted() {
    this.apiHost = process.env.VUE_APP_JOB_BOARD_API_ENDPOINT;

    // display applicant cv
    if (this.$route.query.loadSeeker) {
      const seekerId = this.$route.query.loadSeeker;
      const httpClient = new HttpClient();
      httpClient
        .fetchSeekerForCvteque(seekerId, localStorage.getItem("jwt-token"))
        .then((res) => {
          this.seekers = res.data;
        });
    } else {
      //load default seekers
      this.searchSeeker();
    }
  },
  computed: {
    updateVisibleJobs: function () {
      return this.jobsItems.slice(
        (this.page - 1) * this.perPage,
        this.page * this.perPage
      );
    },
  },
  watch: {
    seekerModel(val) {
      if (val != null) this.tab = 0;
      else this.tab = null;

      if (val.length > 0) {
        this.searchSeeker();
      }
    },
    search(val) {
      // Items have already been loaded
      if (this.items.length > 0 && val) {
        const result = this.items.filter(
          (value) =>
            value.name.toLowerCase() === val.toLowerCase() ||
            value.name.toLowerCase().search(val.toLowerCase()) !== -1
        );
        if (result.length > 0) {
          return;
        }
      }
      this.isLoading = true;
      const httpClient = new HttpClient();
      httpClient
        .fetchCompanyKeyWordsJobTitleAndActivitySectorCompany(
          val,
          localStorage.getItem("jwt-token")
        )
        .then((res) => {
          this.items = res.data;
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.$router.push("/logout");
          } else {
            alert("Une erreur s'est produite");
          }
        })
        .finally(() => (this.isLoading = false));
    },
    where(val) {
      if (val != null) this.locationTab = 0;
      else this.locationTab = null;

      if (typeof val === "object") {
        this.searchJob();
      } else if (typeof val === "string" && val.trim() !== "") {
        this.searchJob();
      }
    },
  },
  methods: {
    async refreshCvView(id, index, idT) {
      const httpClient = new HttpClient();

      if (idT === null) {
        this.currentSeeker = this.seekers[index];
        console.log(this.currentSeeker);
        this.currentCvFilePath = `${process.env.VUE_APP_JOB_BOARD_API_ENDPOINT}/uploads/cv/${this.currentSeeker.cv.fileName}`;
        window.open(this.currentCvFilePath, "_blank");

        return;
      } else {
        this.visible = false
        this.cvData.cvPrevisualisationLink = `${this.apiHost}${
          this.cvData.cvPrevisualisationEndpoint
        }${idT}/${id}?access_token=${localStorage.getItem("jwt-token")}`;
        document.getElementById("cvPrevisualizer").src =
          this.cvData.cvPrevisualisationLink;

        // alert(this.cvData.cvPrevisualisationLink)
        this.visible = true
      }

      await httpClient
          .getCvPreview(
              this.cvData.cvPrevisualisationLink,
              localStorage.getItem("jwt-token")
          )
          .then((value) => {
            this.cvData.cvPrevisualisationContent = value.data;
            // document.getElementById("cvPrevisualizer").src =
            //   document.getElementById("cvPrevisualizer").src;
          })
          .catch((error) => {
            if (error.response.status === 401) {
              this.$router.push("/logout");
            } else {
              alert("Une erreur s'est produite");
              console.log(error);
            }
          });

      console.log(this.currentCvFilePath);
      this.candidateCV =
          idT === null
              ? this.currentCvFilePath
              : `${process.env.VUE_APP_JOB_BOARD_API_ENDPOINT}/download/resume/${idT}/${id}`;
    },
    searchSeeker() {
      let searchContent = null;
      if (this.seekerModel !== null) {
        searchContent = this.seekerModel.map((el) => {
          if (typeof el === "object") {
            return el.name;
          } else {
            return el;
          }
        });

        searchContent = searchContent.length === 0 ? null : searchContent;
      }

      this.isLoading = true;
      const httpClient = new HttpClient();
      httpClient
        .fetchSeekersCompany(searchContent, localStorage.getItem("jwt-token"))
        .then((res) => {
          this.seekers = res.data;
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.$router.push("/logout");
          } else if (err.response.status === 403) {
            alert("Vous n'avez pas accès à cette fonctionnalité. Veuillez vous rapprocher de l'administrateur du site pour un accès.");
          }
          else {
            alert("Une erreur s'est produite");
          }
        })
        .finally(() => (this.isLoading = false));
    },
  },
});
</script>

<style scoped>
.left {
  width: 30%;
  height: 1px;
}

.right {
  width: 70%;
}
</style>
